import { render, staticRenderFns } from "./QuizQuestionMobileHeader.vue?vue&type=template&id=70579127&scoped=true&"
import script from "./QuizQuestionMobileHeader.vue?vue&type=script&lang=js&"
export * from "./QuizQuestionMobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuizQuestionMobileHeader.vue?vue&type=style&index=0&id=70579127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70579127",
  null
  
)

export default component.exports